import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './index.css';
import WorkSpacePage from './components/landing/Workspace';


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
    <Routes>
       
        <Route path="/" element={<WorkSpacePage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
)
